import QRCode from 'qrcode';

/**
 * Generates a QR code image from the given data
 * @param {string} data - The data to encode in the QR code
 * @returns {Promise<string|null>} - A Promise that resolves to a Data URL of the QR code image or null on error
 */
const qrGenerator = async (data) => {
  if (!data) return null;

  try {
    // Generate QR code as a data URL (base64 image)
    const qrImage = await QRCode.toDataURL(data, {
      errorCorrectionLevel: 'H', // High error correction
      type: 'image/png',
      margin: 2,
      width: 200, // width of QR code
      color: {
        dark: '#000000',
        light: '#ffffff',
      },
    });
    return qrImage;
  } catch (err) {
    // Handle error silently
    return null;
  }
};

export default qrGenerator;
